var map = {
	"./bundle-backups-auto.html": 29276,
	"./bundle-backups-confirm-deletion.html": 5847,
	"./bundle-backups-confirm-restoration.html": 80527,
	"./bundle-backups-manual.html": 62834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75405;